<template>
  <div style="minHeight: 100%;">
    <div class="library_box" ref="library_box">
      <div class="head">
        <div class="head_content">
          <img
            src="../../assets/public/home_logo@2x.png"
            class="logo"
            @click="go"
            alt="欢迎来到千年医典数据库，智能阅读海内外中医古籍：素问,黄帝内经,伤寒论,本草纲目等"
          />
          <div class="head_nav" v-show="!issearch">
            <router-link to="index" tag="a" title="点击进入千年医典数据库的首页">
              <p>首页</p>
            </router-link>
            <router-link to="recommend" tag="a" title="点击进入千年医典数据库的中医古籍热门推荐页面">
              <p>
                热门推荐
                <span class="head_hot"></span>
              </p>
            </router-link>
            <router-link
              to="ancientBooks"
              tag="a"
              @click.native="goBooks()"
              title="点击进入千年医典数据库的中医古籍分类页面"
            >
              <p>古籍分类</p>
            </router-link>
            <!-- <router-link to="about" tag='a' @click.native="goBooks()" title="点击进入南京海维数据服务有限公司的相关信息页面"><p>关于我们</p></router-link> -->
            <router-link to="community" tag="a" title="点击进入千年医典数据库的中医社区页面">
              <p>互动社区</p>
            </router-link>
          </div>
          <div class="msg_icon">
            <img
              class="msg_bell"
              src="../../assets/message/mess_icon@2x.png"
              alt
              v-if="unreadmsgArr.length!=0"
            />
            <p class="msg_num" v-show="msg_count!=0&&unreadmsgArr.length!=0">{{msg_count}}</p>
            <div
              class="msg_box infinite-list"
              ref="scrollList"
              v-infinite-scroll="pushnext"
              infinite-scroll-disabled="isloadall"
              infinite-scroll-distance="10"
              infinite-scroll-immediate-check="false"
              v-if="unreadmsgArr.length!=0"
            >
              <p class="msg_title">消息盒</p>
              <div class="msg_newall">
                <div class="msg_newmsg" v-for="(item,index) in unreadmsgArr" :key="index">
                  <!-- <span>{{item.from_user_name}}</span> -->
                  <p v-if="item.type == 1" class="cld5" @click="gomessage(item,index)">
                    <span class="cl66">{{item.from_user_name}}回答了</span>
                    {{item.question_title}}
                    <ins v-if="item.is_read==1"></ins>
                  </p>
                  <p v-if="item.type == 2" class="cld5" @click="gomessage(item,index)">
                    <span class="cl66">{{item.from_user_name}}评论了</span>
                    {{item.question_title}}
                    <ins v-if="item.is_read==1"></ins>
                  </p>
                  <p v-if="item.type == 3">
                    {{item.from_user_name}}评论了你的回答
                    <span class="cld5">该内容已被删除</span>
                    <ins v-if="item.is_read==1"></ins>
                  </p>
                </div>
              </div>
              <router-link tag="div" to="messagecenter" class="msg_all">全部消息</router-link>
            </div>
          </div>
          <!-- <div class="welcome_horn" v-if="islogin&&!is_white&&is_mechanism">
            <img src="../../assets/public/notice_icon@2x.png" alt class="welhorn_img" />
            <marquee
              behavior="scroll"
              scrollamount="4"
              class="welhorn_title"
            >欢迎{{mechanism}}的医学专家们登录千年医典！</marquee>
          </div>-->
          <router-link v-if="!islogin&&!is_white" class="login" to="login" tag="div">
            <span class="login_img"></span>
            <p class="login_p1" title="点击登录千年医典数据库的登录页面">登录</p>
          </router-link>
          <div v-if="islogin&&!is_white" class="login">
            <!-- <router-link tag="p" to="personal" class="login_p2" >{{username}}</router-link> -->
            <!-- <p class="login_p2" >{{username}}</p> -->
            <img :src="head_img" class="login_p2" />
            <p class="login_p3">{{username}}</p>
            <!-- <marquee width=100 scrollamount=4 class="gaga" >嘎嘎嘎嘎嘎嘎嘎嘎嘎~</marquee> -->
            <div class="personal_center">
              <router-link to="books" tag="p">我的书籍</router-link>
              <router-link to="myquestion" tag="p">我的提问</router-link>
              <router-link to="personal" tag="p">个人资料</router-link>
              <p class="signout" @click="signout">退出</p>
            </div>
          </div>
        </div>
      </div>
      <router-view class="library_content"></router-view>
    </div>
    <div class="welcome" v-if="iswelcome">
      <p class="welcome_title">欢迎“{{username}}”登录千年医典数据库</p>
      <div class="welcomebtn" @click="welcome_close">关闭</div>
    </div>
    <!-- 绑定手机号 -->
    <!-- <div class="bindmobile" v-show="is_bind">
      <p class="bind_title">绑定手机号</p>
      <div class="change_user">
        <span>手机号</span>
        <input
          type="text"
          autocomplete="off"
          placeholder="输入手机号"
          class="login_user"
          v-model="mobile"
          @keyup.enter="submit"
        />
        <span>验证码</span>
        <p class="login_mobile">
          <input class="inputtest" v-model="verification_code" type="number" placeholder="输入验证码" />
          <button type="button" :disabled="disabled" @click="sendcode" class="timebtns">{{btntxt}}</button>
        </p>
      </div>
      <p class="login_btn" @click="submit">立即绑定</p>
    </div>-->
    <div class="foot">
      <p class="country_p1">
        <a href="http://www.satcm.gov.cn/" target="_blank" el="nofollow">国家中医药管理局</a>&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
        <a
          href="http://www.catcm.ac.cn/"
          target="_blank"
          el="nofollow"
        >中国中医科学院</a>&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
        <a
          href="http://www.cnipa.gov.cn/"
          target="_blank"
          el="nofollow"
        >国家知识产权局</a>&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
        <a
          href="http://www.wfcms.org/"
          target="_blank"
          el="nofollow"
        >世界中医药学会联合会</a>&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
        <a
          href="https://www.wipo.int/portal/zh/"
          target="_blank"
          el="nofollow"
        >世界知识产权组织</a>&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
        <a
          href="https://www.who.int/"
          target="_blank"
          el="nofollow"
        >世界卫生组织</a>
      </p>
      <p class="country_p3">
        <a href="https://beian.miit.gov.cn" target="_blank" el="nofollow">苏ICP备17033601号-2</a>&nbsp;&nbsp;&nbsp;Copyright © 2017-2019 南京海维可信数据服务有限公司
        <router-link to="cooperate" tag="span" class="business" title="跳转到千年医典数据库的商务合作页面">商务合作</router-link>
        <router-link class="business" to="about" tag="span" title="点击进入南京海维数据服务有限公司的相关信息页面">关于我们</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import clickOutside from "../../util/bind.js";
import { addstamp } from "../../util/stamp";
import { checkheadimg } from "../../util/checkhead_img";
export default {
  data() {
    return {
      // 开启关闭搜索
      issearch: false,
      isseacon: false,
      search_input: null,
      recent_searches: [],
      hot_searches: null,
      // 是否登录
      islogin: false,
      username: "",
      unreadmsgArr: [],
      isshowmsg: false,
      msg_count: null,
      current_page: 1,
      total_pages: 1,
      isloadall: false,
      iscommunity: true,
      iswelcome: false,
      head_img: null,
      // 机构名称
      mechanism: null,
      is_mechanism: false,
      is_white: false,
      isbindnumber: true,
      mobile: null,
      verification_code: null,
      isuserlogin: true,
      issubmit: false,
      disabled: false,
      time: 0,
      btntxt: "获取验证码"
      // 头部导航active
      // active_router:'/index'
    };
  },
  directives: {
    clickOutside // 注册自定义事件
  },
  created() {
    // localStorage.clear()
    this.is_white = this.$store.state.iswhitelist;
    if (typeof this.$store.state.user_id != "undefined") {
      // checkheadimg()
      this.islogin = true;
      this.username = this.$store.state.username;
      this.mechanism = this.$store.state.mechanism;
      // console.log(this.mechanism)
      if (
        this.mechanism != "C端账号" &&
        this.mechanism != "海维可信" &&
        this.mechanism
      ) {
        this.is_mechanism = true;
      } else {
        this.is_mechanism = false;
      }
      // this.head_img = this.$store.state.head_img;
      this.head_img = checkheadimg();
      // console.log(checkheadimg())
      this.loadmsg();
      // console.log(this.$store.state.iswelcome)
      if (
        this.$store.state.iswelcome &&
        this.$store.state.iswelcome == 1 &&
        this.is_mechanism
      ) {
        this.iswelcome = true;
      } else {
        this.iswelcome = false;
      }
    }
    if (this.$store.state.recent_word !== "") {
      this.recent_searches = this.$store.state.recent_word.split(",").reverse();
    }
    this.getHotWord();
  },
  mounted() {
    if (
      this.$route.path == "/ancientBooks" ||
      this.$route.path == "/bookDetail" ||
      this.$route.path == "/bookMarks" ||
      this.$route.path == "/bookTags"
    ) {
      // 古籍分类和古籍详情页面的 背景全白
      this.$refs.library_box.style.background = "#fff";
      // console.log(111)
    } else {
      this.$refs.library_box.style.background = "../../assets/public/bg1.png";
      // console.log(222)
    }
    if (
      this.$route.path == "/community" ||
      this.$route.path == "/questionDetails" ||
      this.$route.path == "/myquestion"
    ) {
      this.iscommunity = true;
    } else {
      this.iscommunity = false;
    }
  },
  methods: {
    onClickOutside() {
      // console.log('dddddddddd')
      this.issearch = false;
    },
    getHotWord() {
      let that = this;
      let datas = {
        user_id: that.$store.state.user_id,
        num: 5
      };
      //				console.log(datas)
      that.$axios
        .get("book/hot_word", {
          params: datas
        })
        .then(res => {
          if (res.data.status_code == 200) {
            that.hot_searches = res.data.data;
          } else {
            return false;
          }
        })
        .catch(function(err) {
          // console.log(err);
          return false;
        });
    },
    search() {
      var sea = document.getElementById("seainput");
      var that = this;
      if (this.issearch) {
        if (this.search_input.length > 0) {
          if (this.iscommunity) {
            that.$router.push({
              path: "/community",
              query: {
                wd: that.search_input
              }
            });
            setTimeout(function() {
              that.$router.go(0);
            }, 50);
          } else {
            this.$store.commit("setRecentWord", this.search_input);
            this.$router.push({
              path: "/search",
              query: {
                wd: this.search_input
              }
            });
          }
          this.search_input = null;
        }
        this.issearch = false;
      } else {
        this.issearch = true;
        setTimeout(function() {
          sea.focus();
        }, 50);
      }
    },
    close() {
      this.issearch = false;
      this.search_input = null;
    },
    push(index, item) {
      this.search_input = item;
      // console.log(item);
      this.$router.push({
        path: "/search",
        query: {
          wd: this.search_input
        }
      });
      this.issearch = false;
    },
    go() {
      this.$router.push("/index");
    },
    signout() {
      let that = this;
      localStorage.removeItem("user_id");
      this.islogin = false;
      setTimeout(function() {
        that.$router.go(0);
      }, 500);
    },
    goBooks() {
      // 清空之前的数据
      this.$store.commit("setCategoryId", null);
      this.$store.commit("setPid", null);
      this.$store.commit("setPPid", 1);
      this.$store.commit("setCategoryName", null);
      this.$store.commit("setPCategoryName", null);
      this.$store.commit("setPPCategoryName", "本土著述");
      this.$store.commit("setLevel", 1);
    },
    pushnext() {
      if (this.current_page != this.total_pages) {
        this.current_page += 1;
        this.loadmsg();
      }
    },
    loadmsg() {
      let that = this;
      var params = {
        user_id: this.$store.state.user_id,
        page: this.current_page,
        page_size: 10,
        type: "window"
      };
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      // console.log(params);
      let url = "community/notices/" + this.$store.state.user_id;
      this.$axios.get(url, { params }).then(function(res) {
        if (res.data.status_code == 200) {
          console.log(res);
          that.msg_count = res.data.data.unread_count;
          that.current_page = res.data.data.current_page;
          that.total_pages = res.data.data.total_pages;

          if (that.current_page == 1) {
            that.unreadmsgArr = res.data.data.notices;
          } else {
            that.unreadmsgArr = that.unreadmsgArr.concat(res.data.data.notices);
          }
          if (that.current_page == that.total_pages) {
            that.isloadall = true;
          }
        }
      });
    },
    gomessage(item, index) {
      // console.log(item)
      var that = this;
      //   this.unreadmsgArr[index].is_read = 2;
      //   this.msg_count -= 1;
      this.$router.push({
        path: "/questionDetails",
        query: {
          qd: item.question_id,
          a: 2,
          nd: item.notice_id
        }
      });
      setTimeout(function() {
        that.$router.go(0);
      }, 200);
    },
    welcome_close() {
      this.iswelcome = false;
      this.$store.commit("setwelcome", 2);
    }
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      //  console.log(this.$route.path)
      if (typeof this.$store.state.user_id != "undefined") {
        this.loadmsg();
      }
      if (this.$route.query.wd) {
        if (this.$store.state.recent_word !== "") {
          this.recent_searches = this.$store.state.recent_word
            .split(",")
            .reverse();
        }
      }
      if (
        this.$route.path == "/ancientBooks" ||
        this.$route.path == "/bookDetail" ||
        this.$route.path == "/bookMarks" ||
        this.$route.path == "/bookTags"
      ) {
        // 古籍分类和古籍详情页面的 背景全白
        this.$refs.library_box.style.background = "#fff";
      } else {
        this.$refs.library_box.style.background = "";
        this.$refs.library_box.style.background = "../../assets/public/bg1.png";
      }
    },
    is_bind() {
      if (this.is_bind) {
        $("body").css({
          overflow: "hidden"
        });
      } else {
        $("body").removeAttr("style");
      }
    }
  },
  computed: {
    getusername() {
      return this.$store.state.username;
    }
  },
  watch: {
    getusername(val) {
      this.username = val;
    }
  }
};
</script>

<style scoped lang="scss"  type="text/css">
a {
  text-decoration: none;
}
.library_box {
  background: url("../../assets/public/bg1.png");
  flex: 1;
}
.head {
  width: 100%;
  height: 100px;
  background: #8f5f3f;
  .head_content {
    width: 1200px;
    height: 100px;
    margin: 0 auto;
    // border: 1px solid red;
    position: relative;
    & > div {
      display: inline-block;
    }
    .logo {
      width: 214px;
      height: 45px;
      margin-top: 27px;
      cursor: pointer;
      vertical-align: top;
    }
    .head_nav {
      // width: 400px;
      height: 100px;
      // border: 1px solid red;
      position: absolute;
      margin-left: 155px;
      top: 0px;
      a {
        width: fit-content;
        height: 70px;
        display: inline-block;
        margin: 0px 25px;
        line-height: 100px;
        color: #ead3b6;
        &.router-link-active {
          border-bottom: 3px solid #e6522b;
        }
        position: relative;
        .head_hot {
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url(../../assets/public/hot_icon@2x.png) center center;
          background-size: cover;
          position: absolute;
          right: -18px;
          top: 36px;
        }
        &:hover {
          color: #fa9964;
        }
      }
    }
    .msg_icon {
      position: relative;
      // top: -10px;
      // right: 140px;
      right: -636px;
      width: 50px;
      height: 100px;
      line-height: 110px;
      text-align: center;
      margin-left: 100px;
      .msg_bell {
        cursor: pointer;
        width: 24px;
        height: 24px;
      }
      .msg_num {
        min-width: 18px;
        max-width: 36px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        background: rgba(211, 45, 37, 1);
        border: 1px solid rgba(255, 255, 255, 1);
        border-radius: 50%;
        color: #fff;
        position: absolute;
        top: 30px;
        right: 2px;
        font-size: 12px;
      }
      .msg_box {
        width: 380px;
        height: 340px;
        background: #fff;
        box-shadow: 0px 1px 8px 0px rgba(12, 8, 7, 0.21);
        display: none;
        position: absolute;
        // border: 1px solid red;
        top: 99px;
        right: -165px;
        z-index: 9999;
        .msg_title {
          width: 100%;
          height: 46px;
          // border: 1px solid green;
          text-indent: 10px;
          box-sizing: border-box;
          padding: 0px 10px;
          // border-bottom: 1px solid #e5e5e5;
          text-align: left;
          line-height: 46px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #333;
        }
        .msg_newall {
          width: 100%;
          height: 250px;
          // border: 1px solid green;
          overflow: scroll;
          overflow-x: hidden;
          overflow-y: scroll;
          box-sizing: border-box;
          padding: 0px 10px;
          .msg_newmsg {
            width: 100%;
            height: 55px;
            border-top: 1px solid #e5e5e5;
            cursor: pointer;
            p {
              width: 100%;
              height: 55px;
              text-indent: 10px;
              line-height: 55px;
              color: #666;
              text-align: left;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              position: relative;
              ins {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #fa453d;
                position: absolute;
                top: 5px;
                right: 5px;
              }
            }
            .cl66 {
              color: #666;
            }
            .cld5 {
              color: #d55d3a;
            }
          }
        }
        .msg_all {
          cursor: pointer;
          width: 100%;
          height: 44px;
          display: block;
          line-height: 44px;
          text-align: center;
          box-sizing: border-box;
          padding: 0px 10px;
          background: #fff;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 600;
          color: rgba(213, 93, 58, 1);
          border-top: 1px solid #e5e5e5;
        }
      }
      &:hover .msg_box {
        display: block;
      }
    }
    .login {
      color: #ead3b6;
      width: 180px;
      // line-height: 100px;
      cursor: pointer;
      // display: flex;
      position: absolute;
      right: -40px;
      // margin-left: 50px;
      .login_img {
        width: 20px;
        height: 20px;
        display: inline-block;
        margin-top: 40px;
        background-image: url(../../assets/public/login_icon_nor@2x.png);
        background-size: cover;
        margin-right: 5px;
        margin-left: 50px;
        vertical-align: sub;
      }
      .login_p1 {
        color: #ead3b6;
        display: inline-block;
        height: 100px;
        // border: 1px solid red;
      }
      .login_p2 {
        color: #fa9964;
        width: 38px;
        height: 38px;
        border-radius: 50%;
        display: block;
        margin: 0 auto;
        margin-top: 22px;
        /*border: 1px solid red;*/
        // white-space: nowrap;
        overflow: hidden;
        // text-overflow: ellipsis;
      }
      .login_p3 {
        width: 100%;
        height: 34px;
        font-size: 14px;
        margin-top: 3px;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .personal_center {
        width: 140px;
        line-height: 43px;
        text-align: center;
        background: #8f5f40;
        display: none;
        box-shadow: 0px 2px 8px 0px rgba(146, 108, 55, 0.31);
        /*border: 1px solid red;*/
        position: absolute;
        top: 96px;
        left: calc(50% - 70px);
        z-index: 199;
        p:hover {
          color: #fa9964;
        }
      }
      &:hover {
        .login_p1,
        .login_p2 {
          color: #fa9964;
        }
        .personal_center {
          display: block;
        }
        .login_img {
          background-image: url(../../assets/public/login_icon_pre@2x.png);
          background-size: cover;
        }
      }
    }
  }
}
.foot {
  width: 100%;
  height: 140px;
  background: #333;
  color: #fff;
  text-align: center;
  p {
    font-size: 16px;
    font-family: PingFangSC-Light;
    font-weight: 300;
    span {
      font-family: PingFangSC-Light;
      font-weight: 300;
    }
    a {
      color: #fff;
      font-family: PingFangSC-Light;
      font-weight: 300;
      cursor: pointer;
    }
  }
  .country_p1 {
    height: 70px;
    line-height: 70px;
    border-bottom: 1px solid;
    border-color: rgba(238, 238, 238, 0.1);
  }
  .country_p2 {
    margin-top: 28px;
    img {
      height: 30px;
      vertical-align: middle;
      &:first-child {
        margin-right: 40px;
        margin-left: 5px;
      }
    }
  }
  .country_p3 {
    margin-top: 22px;
    // border:1px solid red;
    .business {
      margin-left: 10px;
      cursor: pointer;
    }
    .business:hover {
      color: #e6522b;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/nav.vue